/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Metric,
    MetricFromJSON,
    MetricFromJSONTyped,
    MetricToJSON,
} from './';

/**
 * 
 * @export
 * @interface Holdout
 */
export interface Holdout {
    /**
     * 
     * @type {number}
     * @memberof Holdout
     */
    readonly id: number;
    /**
     * 
     * @type {boolean}
     * @memberof Holdout
     */
    archived?: boolean;
    /**
     * The audiences that should see this holdout. To target everyone, use the string \"everyone\" or omit this field. Multiple audiences can be combined with \"and\" or \"or\" using the same structure as audience conditions.
     * @type {Array<object>}
     * @memberof Holdout
     */
    audience_conditions?: Array<object>;
    /**
     * 
     * @type {Array<number>}
     * @memberof Holdout
     */
    audience_ids?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof Holdout
     */
    readonly created_by_user_email?: string;
    /**
     * Timestamp when the Holdout is created
     * @type {Date}
     * @memberof Holdout
     */
    readonly created_time?: Date | null;
    /**
     * Additional context of the Holdout
     * @type {string}
     * @memberof Holdout
     */
    description?: string;
    /**
     * Timestamp until when the Holdout finished
     * @type {Date}
     * @memberof Holdout
     */
    readonly end_time?: Date;
    /**
     * 
     * @type {string}
     * @memberof Holdout
     */
    environment_key?: string;
    /**
     * 
     * @type {string}
     * @memberof Holdout
     */
    key?: string;
    /**
     * List of metrics that are evaluated for the holdout.
     * @type {Array<Metric>}
     * @memberof Holdout
     */
    metrics?: Array<Metric>;
    /**
     * Timestamp until when holdout was last updated
     * @type {Date}
     * @memberof Holdout
     */
    readonly updated_time?: Date;
    /**
     * User-facing name of the Holdout
     * @type {string}
     * @memberof Holdout
     */
    name: string;
    /**
     * The ID of the Project this Group belongs to
     * @type {number}
     * @memberof Holdout
     */
    project_id?: number;
    /**
     * The scope of the Holdout (global/local)
     * @type {string}
     * @memberof Holdout
     */
    scope?: string;
    /**
     * The scope type of the Holdout (include/exclude)
     * @type {string}
     * @memberof Holdout
     */
    scope_type?: string;
    /**
     * Timestamp from when the Holdout is computed
     * @type {Date}
     * @memberof Holdout
     */
    start_time?: Date;
    /**
     * Status of holdout
     * @type {string}
     * @memberof Holdout
     */
    status?: string;
    /**
     * Revision number for tracking changes
     * @type {number}
     * @memberof Holdout
     */
    readonly revision?: number;
    /**
     * The traffic allocation for the Holdout
     * @type {number}
     * @memberof Holdout
     */
    traffic_allocation?: number;
}

export function HoldoutFromJSON(json: any): Holdout {
    return HoldoutFromJSONTyped(json, false);
}

export function HoldoutFromJSONTyped(json: any, ignoreDiscriminator: boolean): Holdout {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'archived': !exists(json, 'archived') ? undefined : json['archived'],
        'audience_conditions': !exists(json, 'audience_conditions') ? undefined : json['audience_conditions'],
        'audience_ids': !exists(json, 'audience_ids') ? undefined : json['audience_ids'],
        'created_by_user_email': !exists(json, 'created_by_user_email') ? undefined : json['created_by_user_email'],
        'created_time': !exists(json, 'created_time') ? undefined : (json['created_time'] === null ? null : new Date(json['created_time'])),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'end_time': !exists(json, 'end_time') ? undefined : (new Date(json['end_time'])),
        'environment_key': !exists(json, 'environment_key') ? undefined : json['environment_key'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'metrics': !exists(json, 'metrics') ? undefined : ((json['metrics'] as Array<any>).map(MetricFromJSON)),
        'updated_time': !exists(json, 'updated_time') ? undefined : (new Date(json['updated_time'])),
        'name': json['name'],
        'project_id': !exists(json, 'project_id') ? undefined : json['project_id'],
        'scope': !exists(json, 'scope') ? undefined : json['scope'],
        'scope_type': !exists(json, 'scope_type') ? undefined : json['scope_type'],
        'start_time': !exists(json, 'start_time') ? undefined : (new Date(json['start_time'])),
        'status': !exists(json, 'status') ? undefined : json['status'],
        'revision': !exists(json, 'revision') ? undefined : json['revision'],
        'traffic_allocation': !exists(json, 'traffic_allocation') ? undefined : json['traffic_allocation'],
    };
}

export function HoldoutToJSON(value?: Holdout | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'archived': value.archived,
        'audience_conditions': value.audience_conditions,
        'audience_ids': value.audience_ids,
        'description': value.description,
        'environment_key': value.environment_key,
        'key': value.key,
        'metrics': value.metrics === undefined ? undefined : ((value.metrics as Array<any>).map(MetricToJSON)),
        'name': value.name,
        'project_id': value.project_id,
        'scope': value.scope,
        'scope_type': value.scope_type,
        'start_time': value.start_time === undefined ? undefined : (value.start_time.toISOString()),
        'status': value.status,
        'traffic_allocation': value.traffic_allocation,
    };
}


